import React from 'react';
import { Cell } from 'react-table';

import { Tooltip } from '@trqk/components';

import { SendColumn } from '../../../../../types';
import { rowHeight } from '../../constants';

interface ChannelNameCellProps {
    cell: Cell<TrqkGapChannel, GapChannelNameCellValue>;
    column: SendColumn<TrqkGapChannel>;
}

export function ChannelNameCell({
    cell,
    column,
}: ChannelNameCellProps): JSX.Element {
    const width = (column?.width as number) ?? 100;
    const {
        value: { channelNameDetection },
    } = cell;

    return (
        <Tooltip
            message={channelNameDetection}
            position="right"
            minWidth={250}
            maxWidth={250}
        >
            <div className="flex items-center" style={{ height: rowHeight }}>
                <p
                    className="text-left respond-to-mouse leading-tight clamp-2-lines-break-words"
                    style={{
                        width: width - 10,
                    }}
                >
                    {channelNameDetection}
                </p>
            </div>
        </Tooltip>
    );
}
